import { defineMessages } from 'react-intl';

export default defineMessages({
  deliveryExpectationMessageText: {
    description: 'Text for the delivery expectation as set by the Delivery Time component',
    defaultMessage: '{days, plural, one {# Business Day} other {# Business Days}}',
    id: '6paC3u',
  },
  deliveryExpectationNoRestrictionText: {
    description: 'Text for the delivery expectation when there is no restriction',
    defaultMessage: 'No Restriction',
    id: 'HuJeYf',
  },
  useDeliverByDateText: {
    description: 'Text for the using deliver by date',
    defaultMessage: 'Use Deliver by Date',
    id: '6gEWEr',
  },
  orText: {
    description: 'Text for the "Or" between the 2 tags',
    defaultMessage: 'if given, otherwise use fallback transit time of',
    id: 'xqLoue',
  },
});
